<template>
  <ComponentResolverPublic v-if="$route.fullPath.includes('/public/')" />
  <App v-else />
</template>

<script>
import App from '@/agilis/components/App/App.vue'
import ComponentResolverPublic from '@/agilis/public/components/ComponentResolverPublic/ComponentResolverPublic.vue'
export default {
  components: {
    ComponentResolverPublic,
    App
  }
}
</script>
